import * as recruitmentTypes from "../../types/admin/recruitmentTypes";

export const updateRecuitCompanyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_RECRUITMENT_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_RECRUITMENT_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_RECRUITMENT_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const duplicateJobAdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DUPLICATE_JOB_AD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DUPLICATE_JOB_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.DUPLICATE_JOB_AD_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};
export const updateJobAdDetailsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_JOB_AD_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_JOB_AD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_JOB_AD_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateJobAdApplicationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_JOB_AD_APPLICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_JOB_AD_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_JOB_AD_APPLICATION_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateJobAdWorkflowReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_JOB_AD_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_JOB_AD_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_JOB_AD_WORKFLOW_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateJobAdStatusReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_JOB_AD_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_JOB_AD_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_JOB_AD_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const deleteJobAdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DELETE_JOB_AD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DELETE_JOB_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.DELETE_JOB_AD_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getJobAdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_JOB_AD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_JOB_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_JOB_AD_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getAllJobAdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_JOB_AD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_JOB_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_JOB_AD_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getPaginatedJobAdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_PAGINATED_JOB_AD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_PAGINATED_JOB_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_PAGINATED_JOB_AD_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};
export const getPaginatedJobFiltersReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_PAGINATED_JOB_FILTERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_PAGINATED_JOB_FILTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case recruitmentTypes.GET_PAGINATED_JOB_FILTERS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
        error: payload,
      };
    default:
      return state;
  }
};
export const getAllJobAdDetailsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_JOB_AD_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_JOB_AD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdDetailsInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_JOB_AD_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        jobAdDetailsInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getJobAdApplicationReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_JOB_AD_APPLICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_JOB_AD_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_JOB_AD_APPLICATION_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateTemplateIdToJobAdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getJobAdDetailsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_JOB_AD_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_JOB_AD_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_JOB_AD_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getJobAdWorkflowReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_JOB_AD_WORKFLOW_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_JOB_AD_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_JOB_AD_WORKFLOW_FAIL:
      return {
        ...state,
        loading: false,
        jobAdInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getAllCompaniesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_COMPANIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_COMPANIES_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getCompanyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getCompanyPublicReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_COMPANY_PUBLIC_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_COMPANY_PUBLIC_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_COMPANY_PUBLIC_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getJobPublicReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_JOB_PUBLIC_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_JOB_PUBLIC_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_JOB_PUBLIC_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const deleteCompanyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DELETE_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DELETE_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.DELETE_COMPANY_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const candidateApplyReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CANDIDATE_APPLY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CANDIDATE_APPLY_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateInfo: payload,
        error: "",
      };
    case recruitmentTypes.CANDIDATE_APPLY_FAIL:
      return {
        ...state,
        loading: false,
        candidateInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const addCandidateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.ADD_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.ADD_CANDIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateInfo: payload,
        error: "",
      };
    case recruitmentTypes.ADD_CANDIDATE_FAIL:
      return {
        ...state,
        loading: false,
        candidateInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getAllCandidatesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_CANDIDATES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_CANDIDATES_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_CANDIDATES_FAIL:
      return {
        ...state,
        loading: false,
        candidateInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getCandidateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_CANDIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        candidateInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_CANDIDATE_FAIL:
      return {
        ...state,
        loading: false,
        candidateInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateCandidateStatusReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_CANDIDATE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_CANDIDATE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateCandidateStatusList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_CANDIDATE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        updateCandidateStatusList: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateCandidateNotesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_CANDIDATE_NOTES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_CANDIDATE_NOTES_SUCCESS:
      return {
        ...state,
        loading: false,
        updateCandidateNotesList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_CANDIDATE_NOTES_FAIL:
      return {
        ...state,
        loading: false,
        updateCandidateNotesList: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateBulkCandidateTalentPoolReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_BULK_CANDIDATE_TALENTPOOL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_BULK_CANDIDATE_TALENTPOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_BULK_CANDIDATE_TALENTPOOL_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateCandidateTalentPoolReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_CANDIDATE_TALENTPOOL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_CANDIDATE_TALENTPOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_CANDIDATE_TALENTPOOL_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const archiveBulkCandidateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.ARCHIVE_BULK_CANDIDATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.ARCHIVE_BULK_CANDIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        companyInfo: payload,
        error: "",
      };
    case recruitmentTypes.ARCHIVE_BULK_CANDIDATE_FAIL:
      return {
        ...state,
        loading: false,
        companyInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const addScreeningAnswerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CANDIDATE_APPLY_SCREENING_ANSWER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CANDIDATE_APPLY_SCREENING_ANSWER_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdScreeningAnswer: payload,
        error: "",
      };
    case recruitmentTypes.CANDIDATE_APPLY_SCREENING_ANSWER_FAIL:
      return {
        ...state,
        loading: false,
        jobAdScreeningAnswer: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateRecruiterAssessmentReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_JOB_AD_RECRUITER_ASSESSMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_JOB_AD_RECRUITER_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdRecruiterAssessment: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_JOB_AD_RECRUITER_ASSESSMENT_FAIL:
      return {
        ...state,
        loading: false,
        jobAdRecruiterAssessment: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const updateCandidateRecruiterAssessmentReducer = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        jobAdCandidateRecruiterAssessment: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_FAIL:
      return {
        ...state,
        loading: false,
        jobAdCandidateRecruiterAssessment: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const getCandidateFromTalentPoolReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_CANDIDATE_FROM_TALENTPOOL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_CANDIDATE_FROM_TALENTPOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        talentPoolList: payload,
        error: "",
      };
    case recruitmentTypes.GET_CANDIDATE_FROM_TALENTPOOL_FAIL:
      return {
        ...state,
        loading: false,
        talentPoolList: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const assignJobToTalentPoolReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.ASSIGN_JOB_TO_TALENTPOOL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.ASSIGN_JOB_TO_TALENTPOOL_SUCCESS:
      return {
        ...state,
        loading: false,
        talentPoolList: payload,
        error: "",
      };
    case recruitmentTypes.ASSIGN_JOB_TO_TALENTPOOL_FAIL:
      return {
        ...state,
        loading: false,
        talentPoolList: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const uploadCandidateFilesReducer1 = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPLOAD_CANDIDATE_CVS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPLOAD_CANDIDATE_CVS_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadCanandaiteFiles: payload,
        error: "",
      };
    case recruitmentTypes.UPLOAD_CANDIDATE_CVS_FAIL:
      return {
        ...state,
        loading: false,
        uploadCanandaiteFiles: [],
      };
    default:
      return state;
  }
};

export const uploadCandidateFilesParseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPLOAD_CANDIDATE_CVS_PARSING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPLOAD_CANDIDATE_CVS_PARSING_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadCanandaiteFiles: payload,
        error: "",
      };
    case recruitmentTypes.UPLOAD_CANDIDATE_CVS_PARSING_FAIL:
      return {
        ...state,
        loading: false,
        uploadCanandaiteFiles: [],
      };
    default:
      return state;
  }
};

export const getAllRecruitCompaniesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_RECRUIT_COMPANIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_RECRUIT_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        recruitCompaniesList: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_RECRUIT_COMPANIES_FAIL:
      return {
        ...state,
        loading: false,
        recruitCompaniesList: [],
      };
    default:
      return state;
  }
};
export const AddJobPostIdReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.ADD_JOB_POST_ID_SUCCESS:
      return {
        ...state,
        addJobPostId: payload,
      };
    default:
      return state;
  }
};

export const getAllStatusesTemplatesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_STATUSES_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_STATUSES_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_STATUSES_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};

export const createStatusesTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CREATE_STATUSES_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CREATE_STATUSES_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.CREATE_STATUSES_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};

export const updateStatusesTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_STATUSES_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_STATUSES_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_STATUSES_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};

export const deleteStatusesTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DELETE_STATUSES_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DELETE_STATUSES_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.DELETE_STATUSES_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};

export const deleteEmailTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DELETE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.DELETE_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        emailTemplatesList: [],
      };
    default:
      return state;
  }
};

export const createEmailTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CREATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CREATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.CREATE_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        emailTemplatesList: [],
      };
    default:
      return state;
  }
};

export const updateEmailTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        emailTemplatesList: [],
      };
    default:
      return state;
  }
};

export const getAllEmailTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_EMAIL_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        emailTemplatesList: [],
      };
    default:
      return state;
  }
};

//Testing
export const getAllOnboardingTemplatesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_ON_BOARDING_TEMPLATES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_ON_BOARDING_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
      };
    case recruitmentTypes.GET_ALL_ON_BOARDING_TEMPLATES_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
        error: "",
      };
    default:
      return state;
  }
};
export const getOnboardingTemplatesReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ON_BOARDING_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ON_BOARDING_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
      };
    case recruitmentTypes.GET_ON_BOARDING_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
        error: "",
      };
    default:
      return state;
  }
};

export const assignOnboardingTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.ASSIGN_ON_BOARDING_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.ASSIGN_ON_BOARDING_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.ASSIGN_ON_BOARDING_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
      };
    default:
      return state;
  }
};
export const createOnboardingTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CREATE_ON_BOARDING_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CREATE_ON_BOARDING_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.CREATE_ON_BOARDING_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
      };
    default:
      return state;
  }
};
export const createOnboardingTasksReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CREATE_ON_BOARDING_TASKS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CREATE_ON_BOARDING_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.CREATE_ON_BOARDING_TASKS_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
      };
    default:
      return state;
  }
};
export const updateOnboardingTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_ON_BOARDING_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_ON_BOARDING_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_ON_BOARDING_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
      };
    default:
      return state;
  }
};

export const deleteOnboardingTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DELETE_ON_BOARDING_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DELETE_ON_BOARDING_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.DELETE_ON_BOARDING_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
      };
    default:
      return state;
  }
};

export const getAllDocumentTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_ALL_DOCUMENT_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_ALL_DOCUMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.GET_ALL_DOCUMENT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};

export const updateDocumentStatusReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_DOCUMENT_STATUS_REQUEST:
      return {
        ...state,
        updateDocumentTypeLoading: true,
      };
    case recruitmentTypes.UPDATE_DOCUMENT_STATUS_SUCCESS:
      return {
        ...state,
        updateDocumentTypeLoading: false,
        updateDocumentTypeList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_DOCUMENT_STATUS_FAIL:
      return {
        ...state,
        updateDocumentTypeLoading: false,
        updateDocumentTypeList: [],
      };
    default:
      return state;
  }
};
export const updateDocumentTypeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_DOCUMENT_TYPE_REQUEST:
      return {
        ...state,
        updateDocumentTypeLoading: true,
      };
    case recruitmentTypes.UPDATE_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        updateDocumentTypeLoading: false,
        updateDocumentTypeList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_DOCUMENT_TYPE_FAIL:
      return {
        ...state,
        updateDocumentTypeLoading: false,
        updateDocumentTypeList: [],
      };
    default:
      return state;
  }
};
export const updateDocumentTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.UPDATE_DOCUMENT_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.UPDATE_DOCUMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.UPDATE_DOCUMENT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        emailTemplatesList: [],
      };
    default:
      return state;
  }
};
export const createMultipleDocumentTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CREATE_MANDATORY_DOCUMENT_TEMPLATE_REQUEST:
      return {
        ...state,
        MandatoryDocumentTemplateLoading: true,
      };
    case recruitmentTypes.CREATE_MANDATORY_DOCUMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        MandatoryDocumentTemplateLoading: false,
        MandatoryDocumentTemplateList: payload,
        error: "",
      };
    case recruitmentTypes.CREATE_MANDATORY_DOCUMENT_TEMPLATE_FAIL:
      return {
        ...state,
        MandatoryDocumentTemplateLoading: false,
        MandatoryDocumentTemplateList: [],
      };
    default:
      return state;
  }
};
export const createDocumentTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.CREATE_DOCUMENT_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.CREATE_DOCUMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.CREATE_DOCUMENT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        onboardingTemplatesList: [],
      };
    default:
      return state;
  }
};
export const deleteDocumentTemplateReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.DELETE_DOCUMENT_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.DELETE_DOCUMENT_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: payload,
        error: "",
      };
    case recruitmentTypes.DELETE_DOCUMENT_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};
export const getEmployeePdfReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case recruitmentTypes.GET_EMPLOYEE_PDF_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case recruitmentTypes.GET_EMPLOYEE_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        employeePdfInfo: payload,
        error: "",
      };
    case recruitmentTypes.GET_EMPLOYEE_PDF_FAIL:
      return {
        ...state,
        loading: false,
        employeePdfInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};
